import { warn } from './logger'

export default function apiListAdapter(API_LIST) {
  return Object.keys(API_LIST).reduce((list, apiName) => {
    const apiInfo = API_LIST[apiName]

    if (typeof apiInfo === 'object') {
      warn(`[Http Warning] The value of 'API_LIST.${apiName}' should not be object, please change to string`)
      list[apiName] = apiInfo.url
    } else {
      list[apiName] = apiInfo
    }

    return list
  }, {})
}
